import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import amplitude from 'amplitude-js';
import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputDropBox from 'apps/auth/components/form/InputDropBox';
import Form from 'apps/auth/components/form-multi/Form';
import TextPopup from 'apps/auth/components/sharedComponents/popups/TextPopup';
import { PROFILE_USA_OCCUPATION } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_CHANGE_US_OCCUPATION_ACTION, AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';

const ProvideOccupation = (props) => {
    const [isDisabledButton, setDisabled] = useState(true);
    const popupRef = useRef(null);
    const { occupationHeader, buttonContinue, occupationSubmitSuccess, gotIt } = usePageMessages();
    const { occupation } = useFields(PROFILE_USA_OCCUPATION);
    const navigate = useNavigate();

    useEffect(() => {
        setDisabled(!occupation?.value);
    }, [occupation?.value]);

    useEffect(() => {
        amplitude.getInstance().logEvent('Occupation Screen Shown');
    }, []);

    const errorHandler = (error) => {
        popupRef.current?.open(<TextPopup text={error?.text} buttonText={gotIt} popupRef={popupRef} />);
    };

    const submitHandler = () => {
        props.toggleModalWithTimer(true, occupationSubmitSuccess, () => {
            amplitude.getInstance().logEvent('Occupation Submitted');
            //refresh page to start flow from beginning
            navigate(0);
        });
    };

    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE_LIMITS} hasBottomPanel leftCloseIcon showChat={false}>
                <HeaderPanel title={occupationHeader} />
                <Form
                    formName={PROFILE_USA_OCCUPATION}
                    action={AUTH_PROFILE_CHANGE_US_OCCUPATION_ACTION}
                    onSubmitHandler={submitHandler}
                    onErrorHandler={errorHandler}
                >
                    <Row indent="adaptive-32-48">
                        <InputDropBox formName={PROFILE_USA_OCCUPATION} field={occupation} />
                    </Row>
                    <FixedBottomPanel isRightAligned>
                        <Button type="submit" caption={buttonContinue} disabled={isDisabledButton} />
                    </FixedBottomPanel>
                </Form>
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};
export default connect(null, { toggleModalWithTimer })(ProvideOccupation);
